<template>
  <KTTable
    title="Borme"
    subtitle="Movimientos Borme"
    :showOnly="true"
    :fields="fields"
    :endpoint="endpoint"
    :responsive="true"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      endpoint: "borme",
      fields: [
        {
          key: "idborme",
          label: "Id Borme",
          sortable: true,
          sticky: true
        },
        {
          key: "anyo",
          label: "Año",
          sortable: true,
          sticky: true
        },
        {
          key: "mes",
          label: "Mes",
          sortable: true,
          sticky: true
        },
        {
          key: "semana",
          label: "Semana",
          sortable: true,
          sticky: true
        },
        {
          key: "estado",
          label: "Movimiento Estado Original",
          sortable: true,
          sticky: true
        },
        {
          key: "moestado",
          label: "Movimiento Estado",
          sortable: true,
          sticky: true
        },
        {
          key: "auditorcuentas",
          label: "Auditor cuentas",
          sortable: false
        },
        {
          key: "capitaldesembolsado",
          label: "Capital desembolsado",
          sortable: false
        },
        {
          key: "capitalsuscrito",
          label: "Capital suscrito",
          sortable: false
        },
        {
          key: "cargo1",
          label: "Cargo 1",
          sortable: false
        },
        {
          key: "cargo2",
          label: "Cargo 2",
          sortable: false
        },
        {
          key: "cargo3",
          label: "Cargo 3",
          sortable: false
        },
        {
          key: "cargo4",
          label: "Cargo 4",
          sortable: false
        },
        {
          key: "cargo5",
          label: "Cargo 5",
          sortable: false
        },
        {
          key: "cif",
          label: "Cif",
          sortable: false
        },
        {
          key: "cifnuevo",
          label: "Cif nuevo",
          sortable: false
        },
        {
          key: "cifvinvulado",
          label: "Cif vinculado",
          sortable: false
        },
        {
          key: "cnaes",
          label: "Cnaes",
          sortable: false
        },
        {
          key: "cpostal",
          label: "Código Postal",
          sortable: false
        },
        {
          key: "email",
          label: "Email",
          sortable: false
        },
        {
          key: "extvia",
          label: "Extvia",
          sortable: false
        },
        {
          key: "fechaconstitucion",
          label: "Fecha constitución",
          sortable: false
        },
        {
          key: "fechadeposito",
          label: "Fecha depósito",
          sortable: false
        },
        {
          key: "fechaduracion",
          label: "Fecha duración",
          sortable: false
        },
        {
          key: "fechaultimoacto",
          label: "Fecha último acto",
          sortable: false
        },
        {
          key: "fj",
          label: "Fj",
          sortable: false
        },
        {
          key: "fjnueva",
          label: "Fjnueva",
          sortable: false
        },
        {
          key: "idfj",
          label: "ID Fj",
          sortable: false
        },
        {
          key: "idfjnueva",
          label: "ID Fjnueva",
          sortable: false
        },
        {
          key: "idpoblacion",
          label: "ID Población",
          sortable: false
        },
        {
          key: "idprovincia",
          label: "ID Provincia",
          sortable: false
        },
        {
          key: "idprovinciareg",
          label: "ID Provincia Reg",
          sortable: false
        },
        {
          key: "mocapital",
          label: "Movimiento Capital",
          sortable: false
        },
        {
          key: "modomicilio",
          label: "Movimiento Domicilio",
          sortable: false
        },
        {
          key: "moobjetosocial",
          label: "Movimiento Objeto Social",
          sortable: false
        },
        {
          key: "morazonsocial",
          label: "Movimiento Razon Social",
          sortable: false
        },
        {
          key: "movcargo",
          label: "Movimiento cargo",
          sortable: false
        },
        {
          key: "nombrecargo1",
          label: "Nombre Cargo 1",
          sortable: false
        },
        {
          key: "nombrecargo2",
          label: "Nombre Cargo 2",
          sortable: false
        },
        {
          key: "nombrecargo3",
          label: "Nombre Cargo 3",
          sortable: false
        },
        {
          key: "nombrecargo4",
          label: "Nombre Cargo 4",
          sortable: false
        },
        {
          key: "nombrecargo5",
          label: "Nombre Cargo 5",
          sortable: false
        },
        {
          key: "nombrevia",
          label: "Nombre via",
          sortable: false
        },
        {
          key: "nuevacreacion",
          label: "Nueva creación",
          sortable: false
        },
        {
          key: "numerocif",
          label: "Número cif",
          sortable: false
        },
        {
          key: "numerovia",
          label: "Número via",
          sortable: false
        },
        {
          key: "objetosocial",
          label: "Objeto social",
          sortable: false
        },
        {
          key: "otrosconceptos",
          label: "Otros conceptos",
          sortable: false
        },
        {
          key: "poblacion",
          label: "Población",
          sortable: false
        },
        {
          key: "provincia",
          label: "Provincia",
          sortable: false
        },
        {
          key: "provinciareg",
          label: "Provincia Reg.",
          sortable: false
        },
        {
          key: "rzs",
          label: "R.Z.S.",
          sortable: false
        },
        {
          key: "rzsnueva",
          label: "R.Z.S. Nueva",
          sortable: false
        },
        {
          key: "sociounico",
          label: "Socio único",
          sortable: false
        },
        {
          key: "sociounicopersonal",
          label: "Socio único personal",
          sortable: false
        },
        {
          key: "sucursal",
          label: "Scucursal",
          sortable: false
        },
        {
          key: "tcargos",
          label: "T. Cargos",
          sortable: false
        },
        {
          key: "tipovia",
          label: "Tipo via",
          sortable: false
        },
        {
          key: "url",
          label: "Url",
          sortable: false
        },
        {
          key: "vinculada",
          label: "Vinculada",
          sortable: false
        }
      ]
    };
  }
};
</script>
